import errorImg from "../../images/error.png";

function Error(props){
return  <div className='relative grid'>
                <div className='absolute flex flex-col justify-self-center mt-[13rem] md:mt-[19rem]' >
                    <div className='flex justify-center'>
                        <img width="100" height="100" src={errorImg} alt="cancel--v1"/>
                    </div>
                    <h1 className='text-xl sm:text-4xl'>Error: {props.error}</h1>
                </div>
        </div>;
}
export default Error;